<template>
  <v-card width="100vw" class="mx-auto my-0 py-0">
    <v-row class="mx-2 mt-2">
      <v-col cols="12">
        <v-text-field label="ค้นหา (ตัวอย่าง. R6601-123456)" clearable prepend-inner-icon="search" v-model="search" @keypress.enter="itemSearch" @click:prepend-inner="itemSearch"></v-text-field>
      </v-col>
    </v-row>
    <v-container :loading="true" color="red" fluid fill-height class="overflow-y-auto" id="scroll-target" style="max-height: 90vh">
      <v-progress-linear v-if="loading" indeterminate color="cyan"></v-progress-linear>
      <v-row dense class="" v-scroll:#scroll-target="onScroll">
        <v-col v-for="(item, i) in items" :key="i" cols="12" md="3">
          <v-card class="mx-auto" max-width="344">
            <v-img :src="$store.getters.staticPath + 'logo_only.png'" height="100px"></v-img>
            <v-card-title>{{ item.ReqOnlineNo }}</v-card-title>
            <v-card-subtitle> {{ item.DateReceived | date }} <br />{{ item.CompanyName }}</v-card-subtitle>
            <v-card-actions>
              <v-btn color="red lighten-2" @click="itemPrint(item)"> pdf </v-btn>

              <v-spacer></v-spacer>

              <v-btn icon @click="item.show = !item.show">
                <v-icon>{{ item.show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
              <!-- {{ offsetTop }}/{{ winH }} -->
            </v-card-actions>

            <v-expand-transition>
              <div v-show="item.show">
                <v-divider></v-divider>

                <v-card-text> </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
        <v-progress-linear v-if="loading" indeterminate color="cyan"></v-progress-linear>
        <v-col cols="12" md="3" v-if="pageNo < pageCount">
          <v-card ref="moreCard" class="mx-auto" max-width="344" color="#26c6da" dark @click="more()">
            <!-- <v-img :src="$store.getters.staticPath + 'logo_only.png'" height="100px"></v-img> -->
            <v-card-title> more... </v-card-title>
            <v-card-subtitle>
              &nbsp; <br />
              &nbsp;</v-card-subtitle
            >
          </v-card>
        </v-col>

        <v-col cols="12" v-if="loading">
          <div class="text-center mt-5">
            <v-progress-circular v-if="loading" indeterminate color="cyan"></v-progress-circular>
          </div>
        </v-col>
        <v-col cols="12" v-if="pageCount === 0">
          <div class="text-center mt-5">ไม่พบข้อมูล</div>
          <div class="text-center mt-5">
            <v-btn color="" @click="clearSearch()"> reload </v-btn>
          </div>
        </v-col>
      </v-row>
      <pdf ref="pdfItem" :title="'<v-icon dark>print</v-icon>'"></pdf>
    </v-container>
  </v-card>
</template>

<script>
// @ is an alias to /src
import pdf from '@/components/customers/pdf_CustomerReq'
import itemService from '@/store/api/services/customersService'
import dropzone from '@/components/dropzoneCompV2_Encode'
import { Line as LineChartGenerator } from 'vue-chartjs'
export default {
  name: 'serviceList',
  components: { pdf, dropzone },
  data: () => ({
    search: '',
    offsetTop: 0,
    winH: 0,
    loading: true,
    pages: 0,
    pageNo: 1,
    pageCount: 1,
    message: process.env.NODE_ENV,
    items: {},
    itemSelected: {}
  }),
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    this.loadinit()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    test() {
      const query = new google.visualization.Query('https://docs.google.com/spreadsheets/d/12XlqAwMP4rW7Jd8Ypd1SdST3dcXbBjmI1cKlk13G23w/edit?usp=sharing')
      query.send((response) => {
        const options = {
          title: 'Creating a Chart from a Separate Spreadsheet'
        }
        const data = response.getDataTable()

        console.log('data google', data)
      })
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop
      this.winH = e.target.scrollHeight - e.target.clientHeight
      console.log('abs(this.offsetTop - this.winH)', Math.abs(this.offsetTop - this.winH))
      if (Math.abs(this.offsetTop - this.winH) < 20) {
        this.more()
      }
    },
    itemPrint(item) {
      // this.itemSelected.Email = this.$store.state.users.custmain.username
      let payload = {
        pageNo: 1,
        rowsPerPage: 50,
        sortBy: 'List',
        descending: true,
        search: '',
        ID: item.ID,
        serviceType: 'TSC'
      }
      // if (!item.SampleList) {
      // let res = await itemService.sampleListByParam(payload)
      if (payload.serviceType === 'TSC') {
        itemService.sampleListByParam(payload).then((res) => {
          item.SampleList = res.data.data
          let pdf = { ...item }
          this.$refs.pdfItem.downloadPDF(pdf)
        })
      }
    },
    async itemSearch() {
      this.pageNo = 1
      this.pageCount = 1
      if (this.pageNo > this.pageCount) return
      this.loadinit()
    },
    async clearSearch() {
      this.search = ''
      this.pageNo = 1
      this.pageCount = 1
      if (this.pageNo > this.pageCount) return
      this.loadinit()
    },
    async more() {
      this.pageNo++
      if (this.pageNo > this.pageCount) return
      this.loadinit()
    },
    async loadinit() {
      this.loading = true
      let payload = {
        pageNo: this.pageNo,
        rowsPerPage: 5,
        sortBy: 'DateReceived desc',
        search: '',
        Email: this.$store.getters.userCust.Email,
        search_ReqOnlineNo: this.search
      }
      console.log('payload', payload)
      let res = await itemService.testingReqListByParam(payload)
      if (res.data.totalRecords === 0) {
        this.pageNo = 1
        this.pageCount = 0
        this.items = []
        this.loading = false
        return
      }
      this.pageNo = res.data.pageNo
      this.pageCount = res.data.pageCount
      let loadItems = res.data.data.map((m) => {
        m.show = false
        return m
      })

      if (this.pageNo === 1) {
        this.items = loadItems
      } else {
        this.items = [...this.items, ...loadItems]
      }

      //--
      this.loading = false
    }
  }
}
</script>

<style scoped></style>
